var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00074 -0.00041008C1.22674 -0.00041008 1.45374 0.0755901 1.64074 0.23159L7.01174 4.70759L12.3737 0.39259C12.8027 0.0455899 13.4327 0.11359 13.7797 0.54459C14.1257 0.97459 14.0577 1.60359 13.6267 1.95059L7.62674 6.77859C7.25674 7.07759 6.72574 7.07359 6.35974 6.76759L0.359738 1.76759C-0.0642614 1.41459 -0.121262 0.78359 0.231738 0.35959C0.429738 0.12259 0.713738 -0.00041008 1.00074 -0.00041008Z",
    fill: "#757D8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdownIcon);
export default __webpack_public_path__ + "static/media/arrowdown_icon.4f887f67e4678e3d088f0cdb465f3c03.svg";
export { ForwardRef as ReactComponent };